var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassRankedLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 762 226",
    style: {
      enableBackground: "new 0 0 762 226"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1F5EEF;}\n\t.st1{fill:#5D90F9;}\n\t.st2{fill:#122B78;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.1,142.8c15.6,0,28.3-12.7,28.3-28.3c0-15.6-12.7-28.3-28.3-28.3c-15.6,0-28.3,12.7-28.3,28.3 C73.8,130.2,86.5,142.8,102.1,142.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.3,61.1c15.6,0,28.3-12.7,28.3-28.3S43.9,4.5,28.3,4.5S0,17.2,0,32.8S12.7,61.1,28.3,61.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.6,151.1c-14.8,0-26.8,12-26.8,26.8v17.3c0,14.7,11.9,26.5,26.5,26.5h27.2V178 C128.5,163.1,116.5,151.1,101.6,151.1L101.6,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.7,222V96.2c0-14.8-12-26.8-26.8-26.8C13,69.3,1,81.3,1,96.2v82.6C1,202.7,20.3,222,44.1,222H54.7 L54.7,222z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220,4.5H83.1c-5.2,0-9.3,4.2-9.3,9.3v35.1c0,5.2,4.2,9.3,9.3,9.3H220c5.2,0,9.3-4.2,9.3-9.3V13.8 C229.3,8.7,225.1,4.5,220,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.1,86.3h-66.1c-5.2,0-9.3,4.2-9.3,9.3v35.1c0,5.2,4.2,9.3,9.3,9.3h66.1c5.2,0,9.3-4.2,9.3-9.3V95.6 C229.4,90.5,225.2,86.3,220.1,86.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.1,168.1h-66.1c-5.2,0-9.3,4.2-9.3,9.3v35.1c0,5.2,4.2,9.3,9.3,9.3h66.1c5.2,0,9.3-4.2,9.3-9.3v-35.1 C229.4,172.2,225.2,168.1,220.1,168.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logotype"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M352.6,62.2l-0.2,0.8c-3,16.2-11.4,23.4-27,23.4c-18.6,0-29.2-12.9-29.2-35.5s10.7-35.6,29.2-35.6 c15.4,0,24,7.5,27,23.4l0.2,0.8l17.7-2.6l-0.1-0.8c-3.4-23.9-18.8-36.5-44.5-36.5c-29.8,0-48.3,19.7-48.3,51.3 s18.5,51.2,48.3,51.2c25.3,0,40.7-12.6,44.5-36.5l0.1-0.9L352.6,62.2L352.6,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M490.5,86.4c-1.2,0.2-2.5,0.3-3.8,0.3c-3.5,0-4.8-1.5-4.8-5.7V55.6c0-7.7,0-31.1-32-31.1 c-17.7,0-29.3,8.8-31.8,24l-0.1,0.8l16.2,2.8l0.2-0.8c1.8-8.6,6.5-12.2,15.7-12.2c10.2,0,14.9,5.2,14.9,16.3V58 c-4.5-0.7-9.4-1-14-1c-23,0-35.2,7.7-35.2,22.3c0,14.6,10.2,23,26,23c10.9,0,19.9-4,25-11.1c1.6,7.3,6.3,10.3,15.7,10.3 c3.1,0,5.6-0.3,8.2-0.9l0.7-0.2V86.2L490.5,86.4L490.5,86.4z M465.1,70.6v8.1c-3.8,5.7-11.2,9.3-19.3,9.3c-7.6,0-11.2-3-11.2-9.1 c0-6.2,5.6-9.1,18-9.1C456.4,69.8,460.4,70.1,465.1,70.6L465.1,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M534.2,55.4c-12.5-2.8-16-5-16-10.3c0-5.3,4.4-8.5,12.3-8.5c6.8,0,15.1,2.5,16.1,14.3l0.1,0.9l15.8-1.8v-0.8 c-0.7-17.2-12.1-26.7-32.1-26.7c-17.7,0-29.2,9.3-29.2,23.6c0,13.1,7.7,19.3,29.5,23.9c10.9,2.3,15.4,3.9,15.4,9.7 c0,5.8-4.2,8.3-12.8,8.3c-11.3,0-17.2-4.7-18.2-14.2l-0.1-0.9l-16.4,1.9l0.1,0.8c1.3,17.1,13.7,26.6,34.9,26.6 c18.4,0,29.9-9,29.9-23.4C563.4,63.1,550.7,59.1,534.2,55.4L534.2,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M608.9,55.4c-12.5-2.8-16-5-16-10.3c0-5.3,4.4-8.5,12.3-8.5c6.8,0,15.1,2.5,16.1,14.3l0.1,0.9l15.8-1.8v-0.8 c-0.7-17.2-12.1-26.7-32.1-26.7c-17.7,0-29.2,9.3-29.2,23.6c0,13.1,7.7,19.3,29.5,23.9c10.9,2.3,15.4,3.9,15.4,9.7 c0,5.8-4.2,8.3-12.8,8.3c-11.3,0-17.2-4.7-18.2-14.2l-0.1-0.9l-16.4,1.9l0.1,0.8c1.3,17.1,13.7,26.6,34.9,26.6 c18.4,0,29.9-9,29.9-23.4C638.1,63.1,625.5,59.1,608.9,55.4L608.9,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.2,184.1c13.8-3.7,21.7-14.1,21.7-28.7c0-19.7-11.6-30.2-33.6-30.2h-39v99.5h18.4v-39h11.9l25.1,39h22 L334.2,184.1L334.2,184.1z M301.7,140.3H321c11,0,16.1,4.7,16.1,14.9c0,10.8-5.3,16.1-16.3,16.1h-19L301.7,140.3L301.7,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440.7,210c-1.2,0.2-2.5,0.3-3.8,0.3c-3.5,0-4.8-1.5-4.8-5.7v-25.4c0-7.7,0-31.1-32-31.1 c-17.7,0-29.3,8.8-31.8,24l-0.1,0.8l16.2,2.8l0.2-0.8c1.8-8.6,6.5-12.2,15.7-12.2c10.2,0,14.9,5.2,14.9,16.3v2.5 c-4.5-0.7-9.4-1-14-1c-23,0-35.2,7.7-35.2,22.3c0,14.6,10.2,23,26,23c10.9,0,19.9-4,25-11.1c1.6,7.3,6.3,10.3,15.7,10.3 c3.1,0,5.6-0.3,8.2-0.9l0.7-0.2v-14.2L440.7,210L440.7,210z M415.2,194.1v8.1c-3.8,5.7-11.2,9.3-19.3,9.3c-7.6,0-11.2-3-11.2-9.1 c0-6.2,5.6-9.1,18-9.1C406.6,193.4,410.6,193.6,415.2,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M492.7,148.1c-10.6,0-18.8,4.4-23.6,12.6l-0.1-11.2h-16.3v75h17.3V187c0-14,7.1-22.6,18.6-22.6 c9.7,0,14,5.3,14,17.3v42.8h17.3v-46.6C519.9,158.4,510.5,148.1,492.7,148.1L492.7,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M643.2,148.1c-21.2,0-36.1,16-36.1,38.9c0,22.9,14.9,39,37,39c17,0,28.4-8.1,32.2-22.7l0.2-0.9l-14.5-3.1 l-0.2,0.7c-2.6,7.5-8.4,11.2-17.7,11.2c-10.8,0-17.6-6.5-19.4-18.4h52.6l0.1-0.8c0.2-2.1,0.3-4,0.3-6.2 C677.7,162.5,664.5,148.1,643.2,148.1L643.2,148.1z M624.9,179.6c1.9-10.8,8.5-16.9,18.2-16.9c9.7,0,16.2,6,17.3,16.9H624.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M401.3-0.4H384v101.3h17.3V-0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M576,182.2l28.8-32h-21.3l-28.3,32.7v-58.6h-16.8v100.9h16.8v-22.7l8.9-9.7l23,32.4h20.3L576,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M744.9,124.2v34.7c-4.9-6.9-12.4-10.3-22.7-10.3c-20.9,0-34.3,15.2-34.3,38.8s13.5,39.1,34.3,39.1 c11,0,18.8-4.1,23.8-12.5l0.2,11h16.1V124.2H744.9L744.9,124.2z M724.8,210.8c-12.1,0-19.3-8.8-19.3-23.4 c0-14.7,7.2-23.1,19.3-23.1c12.1,0,20.7,9.3,20.7,23.1C745.5,201.2,737.2,210.8,724.8,210.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassRankedLogo);
export default __webpack_public_path__ + "static/media/classRankedLogo.b637e79cef6f549671541c4680305437.svg";
export { ForwardRef as ReactComponent };